










import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { RestaurantRestaurantTypeEnum } from '@/api/model';

@Component
export default class RestaurantTypeSelect extends Vue {
  @Prop({ default: '' })
  value!: string;

  @Emit()
  input(value: string) {
    return value;
  }

  get types(): string[] {
    return Object.values(RestaurantRestaurantTypeEnum);
  }
}
